import React from 'react'
import LevelOne from '../../dental/mobile/LevelOne';

const ConicalConnection = (props) => {
	return (
		<LevelOne
			system={"conicalConnection"}
		/>
	)
}

export default ConicalConnection